
export class Personal {
    n?:string;
    idpersonal?:number;
    tipodocumento?:string;
    documento?:string;
    nombre?:string;
    sueldo?:number=0;
    celular?:string;
    direccion?:string;
    correo?:string;
    fecha_ingreso?:string;
    estado?:string;
    fechareg?:string;
    fechamod?:string;
    activo?:boolean;
    current_user?:string;
    cargo?:string;
    empresa?:string;
    sexo?:string;
    nacionalidad?:string;
    estadocivil?:string;
    option?:string;
    operacioncliente?:string;
    idusuario_id?:number;
    idusuario?:any;
    idnivel?:any;
    idsucursal?:number;
    constructor(){
    }
}
